import { BillingAddressForm, useToast } from 'grabbitbot-legacy-ui'
import { paymentClient } from '../../api'

/** Equivalent of legacy `PaymentBillingViewComponent`. */
export function PaymentBillingPage() {
  const { showToast } = useToast()
  return (
    <div>
      <h1>Billing address</h1>
      <BillingAddressForm payment={paymentClient} className="screener-form" onSaved={() => showToast('Billing address saved', 'success')} />
    </div>
  )
}
